import { useCallback, useState } from "react"

import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { Button, Divider, Input, Message } from "semantic-ui-react"

import actions from "actions"
import api from "api"
import { useAppDispatch, useAppSelector } from "store"

function ResetPassword() {
  const { t } = useTranslation()
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const error = useAppSelector((state) => state.entry.error)

  const dispatch = useAppDispatch()
  const setError = useCallback(
    (e) => {
      dispatch(actions.entry.updateError(e))
    },
    [dispatch],
  )

  const navigate = useNavigate()

  const [params] = useSearchParams()
  const token = params.get("token")

  const resetPassword = () => {
    setLoading(true)
    setError("")
    api.auth.updatePasswordWithToken(
      token,
      password,
      () => {
        setLoading(false)
        toast(t("entry.resetPassword.success"))
        navigate("/")
      },
      (err) => {
        setLoading(false)
        setError(err.message)
      },
    )
  }

  if (!token || error) {
    return (
      <>
        <h2>Password reset</h2>
        <Message error>
          <Message.Header>{error || t("entry.resetPassword.invalidToken.title")}</Message.Header>
          <Message.Content>{t("entry.resetPassword.invalidToken.message")}</Message.Content>
        </Message>
        <div style={{ textAlign: "center", marginTop: 36 }}>
          <Button as={Link} to="/" primary>
            {t("entry.returnToLogin")}
          </Button>
        </div>
      </>
    )
  }

  return (
    <div>
      <h2>Password reset</h2>
      <p>{t("entry.resetPassword.info")}</p>
      <Divider hidden />
      <Input
        fluid
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoFocus
        placeholder={t("entry.login.password")}
      />
      <div style={{ marginTop: 30, textAlign: "right" }}>
        <Button primary content={t("entry.resetPassword.change")} onClick={resetPassword} loading={loading} />
      </div>
    </div>
  )
}

export default ResetPassword
